(function () {
  function getContent(trigger) {
    return trigger.nextElementSibling;
  }

  function open(trigger) {
    var wrapper = trigger.parentElement;
    var content = getContent(trigger);
    content.hidden = false;
    wrapper.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    wrapper.dispatchEvent(new CustomEvent('dsnavtoggle', { bubbles: true }));
  }

  function close(trigger) {
    var wrapper = trigger.parentElement;
    var content = getContent(trigger);
    wrapper.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    content.hidden = true;
    wrapper.dispatchEvent(new CustomEvent('dsnavtoggle', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.ds-nav-disclosure > button');

    document.querySelectorAll('.ds-nav-disclosure.is-open').forEach(function (wrapper) {
      var ownedByTrigger = trigger && trigger.parentElement === wrapper;
      if (!ownedByTrigger && !wrapper.contains(e.target)) {
        close(wrapper.querySelector(':scope > button'));
      }
    });

    if (!trigger) return;
    e.preventDefault();
    if (trigger.parentElement.classList.contains('is-open')) {
      close(trigger);
    } else {
      open(trigger);
    }
  });

  document.addEventListener('focusout', function (e) {
    var wrapper = e.target.closest('.ds-nav-disclosure');
    if (!wrapper) return;
    setTimeout(function () {
      if (!wrapper.contains(document.activeElement) && wrapper.classList.contains('is-open')) {
        close(wrapper.querySelector(':scope > button'));
      }
    });
  });

  document.addEventListener('keyup', function (e) {
    if (e.code.toUpperCase() !== 'ESCAPE') return;
    var wrapper = e.target.closest('.ds-nav-disclosure.is-open');
    if (!wrapper) return;
    var trigger = wrapper.querySelector(':scope > button');
    close(trigger);
    trigger.focus();
  });

  var header = document.querySelector('.header-wrapper');

  class DsHeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('dsnavtoggle', this.onToggle.bind(this));
    }

    onToggle() {
      if (!header) return;
      var wrapper = this.querySelector(':scope > .ds-nav-disclosure');
      header.preventHide = wrapper ? wrapper.classList.contains('is-open') : false;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        Math.floor(header.getBoundingClientRect().bottom) + 'px'
      );
    }
  }

  customElements.define('ds-header-menu', DsHeaderMenu);
})();
